import React, { Component } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

import '../globalStyles.css';
import Navbar from './Navbar';
import Footer from './Footer';
import { lightYellow, teal } from '../colors';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ChildrenContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

class TemplateWrapper extends Component {
  static propTypes = {
    children: PropTypes.node,
    currentPath: PropTypes.string,
    backgroundColor: PropTypes.string,
    linkColorHover: PropTypes.string,
    submenuId: PropTypes.number,
  };

  static defaultProps = {
    backgroundColor: teal,
    linkColorHover: lightYellow,
  };

  renderContent = (data) => {
    const {
      children, currentPath, backgroundColor, linkColorHover, submenuId,
    } = this.props;

    return (
      <LayoutContainer>
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
          <title>{data?.site?.siteMetadata?.title}</title>
          <meta
            name="description"
            content={data?.site?.siteMetadata?.description}
          />

          <meta name="google-site-verification" content="Goh-2yIUhvq5GM2khgHfnAvwRtHNfgKrYYU0o2sW2-U" />

          <link rel="canonical" href={`https://presono.com${currentPath}`} />

          <link rel="icon" sizes="144x144" href="/img/favicon.ico" />

          {/* icon for your web application used to represent it when added to the Home screen on iOS,
          Since iOS 8+, iPads have required an image with a 180×180 resolution. Other devices will downscale it. */}
          <link rel="apple-touch-icon" sizes="180x180" href="/img/apple-touch-icon.png" />

          {/* is a suggested color that user agents should use to customize the display of the page or of the surrounding user interface */}
          <meta name="theme-color" content="#34BFC9" />

          {/* open graph tags are important for a rich preview on social media (facebook, instagram, linkedin,...) when a presono link is shared
          - documentation: https://ogp.me/ */}
          <meta property="og:url" content={`https://presono.com${currentPath}`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={data?.site?.siteMetadata?.title} />
          <meta property="og:description" content={data?.site?.siteMetadata?.description} />
          <meta property="og:site_name" content="presono GmbH" />
          <meta property="og:image" content="https://presono.com/img/general_snippet_image.png" />

          {/* important for a rich preview on twitter when a presono link is shared
          - documentation: https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/abouts-cards */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`https://presono.com${currentPath}`} />
          <meta name="twitter:site" content="@presono_startup" />
          <meta name="twitter:title" content={data?.site?.siteMetadata?.title} />
          <meta name="twitter:description" content={data?.site?.siteMetadata?.description} />
          <meta name="twitter:image" content="https://presono.com/img/general_snippet_image.png" />

          {/* Domain Verification is the process of telling Facebook that you own the website, administration at Meta Business Manager */}
          <meta name="facebook-domain-verification" content="fjngyws05maj4aclkk1k7pllybxboq" />
          <meta httpEquiv="Cache-Control" content="max-age=0" />

          {
            (typeof document === 'undefined' || !document.getElementById('datareporter')) && (
              <script
                id="datareporter"
                src="https://webcachex-eu.datareporter.eu/loader/v2/cmp-load.js?url=004d9921-f1a9-4162-a568-70a955e92227.74WCWY1Rl72N.d4X"
                defer
              />
            )
          }
        </Helmet>
        <Navbar
          currentPath={currentPath}
          backgroundColor={backgroundColor}
          linkColorHover={linkColorHover}
          submenuId={submenuId}
        />
        <div className="scrollable">
          <ChildrenContainer>{children}</ChildrenContainer>
          <Footer currentPath={currentPath} />
        </div>
      </LayoutContainer>
    );
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query HeadingQuery {
            site {
              siteMetadata {
                title
                description
              }
            }
          }        
        `}
        render={this.renderContent}
      />
    );
  }
}

export default TemplateWrapper;
